// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IHsaCustodianConfigDto
 */
export interface IHsaCustodianConfigDto {
    /**
     * 
     * @type {number}
     * @memberof IHsaCustodianConfigDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IHsaCustodianConfigDto
     */
    name?: string;
}

/**
 * Check if a given object implements the IHsaCustodianConfigDto interface.
 */
export function instanceOfIHsaCustodianConfigDto(value: object): value is IHsaCustodianConfigDto {
    return true;
}

export function IHsaCustodianConfigDtoFromJSON(json: any): IHsaCustodianConfigDto {
    return IHsaCustodianConfigDtoFromJSONTyped(json, false);
}

export function IHsaCustodianConfigDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IHsaCustodianConfigDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function IHsaCustodianConfigDtoToJSON(json: any): IHsaCustodianConfigDto {
    return IHsaCustodianConfigDtoToJSONTyped(json, false);
}

export function IHsaCustodianConfigDtoToJSONTyped(value?: IHsaCustodianConfigDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

